var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" "+_vm._s(_vm.$t('events.general.your_decision'))+": "),_c('span',{class:'history-event-decision--' + this.decision},[_vm._v(_vm._s(_vm.decisionLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }